// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1GZhc","label":"Section_label__3NYRL","contentWrap":"Section_contentWrap__2oPwl","footer":"Section_footer__2epz1","footerInner":"Section_footerInner__1FJD6"};